import { useScrollReveal } from '@/hooks/useScrollReveal';

const messages = [
  { from: 'ai', text: 'Здравствуйте! Видел ваш запрос по SEO-продвижению интернет-магазина. Подскажите, какие задачи стоят перед вами?' },
  { from: 'user', text: 'Ищу подрядчика для SEO-продвижения. Нужен рост продаж.' },
  { from: 'ai', text: 'Понял. Какая тематика магазина и какой сейчас ежемесячный трафик?' },
  { from: 'user', text: 'Электроника. Около 18 000 в месяц. Подрядчик есть, но не устраивает темп.' },
  { from: 'ai', text: 'Принято. Давайте созвонимся на 20 минут — покажем гипотезы и план первых 30 дней. Завтра в 14:00 или 17:00?' },
  { from: 'user', text: 'Давайте завтра в 14:00. Скиньте ссылку на созвон.' },
];

export default function TLDialog() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { ref: descRef, revealed: descRevealed } = useScrollReveal({ delay: 200 });
  const { ref: chatRef, revealed: chatRevealed } = useScrollReveal({ delay: 300 });

  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <span
            ref={labelRef}
            className={`inline-block text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}
          >
            Демо-диалог
          </span>
          <h2
            ref={titleRef}
            className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}
          >
            Пример диалога, который ведёт <span className="text-primary-500">AIGAM</span>
          </h2>
          <p
            ref={descRef}
            className={`mt-5 text-[16px] text-foreground-500 leading-relaxed max-w-md reveal-fade-up ${descRevealed ? 'revealed' : ''}`}
          >
            ИИ не просто отвечает шаблонами — он задаёт уточняющие вопросы, проверяет бюджет и реальные потребности, а в конце переводит клиента на ваш календарь.
          </p>
          <ul className="mt-8 space-y-3 max-w-md">
            {[
              'Контекстный ответ под формулировку запроса',
              'Квалификация по бюджету, срокам и масштабу',
              'Передача в CRM или Telegram менеджера',
            ].map((item) => (
              <li key={item} className="flex items-start gap-2.5 text-[14px] text-foreground-700">
                <span className="mt-0.5 w-5 h-5 rounded-full bg-primary-500 text-background-50 flex items-center justify-center shrink-0">
                  <i className="ri-check-line text-[12px]"></i>
                </span>
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-7">
          <div
            ref={chatRef}
            className={`rounded-3xl bg-background-950 p-3 md:p-4 border border-background-800 reveal-fade-up ${chatRevealed ? 'revealed' : ''}`}
          >
            <div className="flex items-center justify-between px-4 py-3 border-b border-background-50/10">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center text-background-50 font-bold">A</div>
                <div>
                  <div className="text-background-50 font-semibold text-[15px]">AIGAM Sales</div>
                  <div className="text-[11px] text-accent-400 flex items-center gap-1.5">
                    <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
                    онлайн
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-3 text-background-50/40">
                <i className="ri-search-line"></i>
                <i className="ri-more-2-fill"></i>
              </div>
            </div>
            <div className="p-4 md:p-6 space-y-3 max-h-[480px] overflow-y-auto no-scrollbar">
              {messages.map((msg, i) => (
                <div
                  key={i}
                  className={`fade-up flex ${msg.from === 'ai' ? 'justify-end' : 'justify-start'}`}
                  style={{ animationDelay: `${i * 150}ms` }}
                >
                  <div
                    className={`max-w-[78%] rounded-2xl px-4 py-3 text-[14.5px] leading-relaxed ${
                      msg.from === 'ai'
                        ? 'bg-primary-500 text-background-50 rounded-br-md'
                        : 'bg-background-50/10 text-background-50 rounded-bl-md'
                    }`}
                  >
                    {msg.text}
                  </div>
                </div>
              ))}
              <div className="flex justify-end">
                <div className="flex items-center gap-1 px-4 py-3 rounded-2xl bg-primary-500/70 text-background-50">
                  <span className="w-1.5 h-1.5 rounded-full bg-background-50 animate-bounce"></span>
                  <span className="w-1.5 h-1.5 rounded-full bg-background-50 animate-bounce" style={{ animationDelay: '0.15s' }}></span>
                  <span className="w-1.5 h-1.5 rounded-full bg-background-50 animate-bounce" style={{ animationDelay: '0.3s' }}></span>
                </div>
              </div>
            </div>
            <div className="px-4 py-3 border-t border-background-50/10 flex items-center gap-3">
              <i className="ri-emotion-line text-background-50/40"></i>
              <div className="flex-1 text-[13px] text-background-50/40">Сообщение…</div>
              <i className="ri-attachment-2 text-background-50/40"></i>
              <i className="ri-mic-line text-background-50/40"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}